import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ERROR_TO_PRINT from '@/errorManagement/errorMapping';
import Stopper from '@/errorManagement/errorPages/default';

function Core({ children, ...props }) {
  const { handlingCode, errorToPrint, phone900, homeUrl } = useSelector(
    (state) => state.error
  );
  return (
    <>
      {handlingCode < 0 &&
        (ERROR_TO_PRINT[errorToPrint] ? (
          ERROR_TO_PRINT[errorToPrint]({
            ...props,
            buttonHref: `tel:${phone900.replace(/\s/g, '')}`,
            buttonText: `Llamar gratis al ${phone900}`,
            linkUrl: homeUrl,
          })
        ) : (
          <Stopper {...props} buttonHref={phone900} buttonText={phone900} />
        ))}
      {handlingCode >= 0 && children}
    </>
  );
}

Core.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Core;
